import { Service } from '@/request/http.js'

// 帐号列表
export function accountList (data) {
  return Service({
    url: '/api/account',
    method: 'post',
    params: data
  })
}

// 账号详情
export function accountDetail (data) {
  return Service({
    url: '/api/account',
    method: 'post',
    params: data
  })
}

// 保存账号
export function accountSave (data) {
  return Service({
    url: '/api/account',
    method: 'post',
    params: data
  })
}
// 修改账户状态.
export function changeStatus (data) {
  return Service({
    url: '/api/account',
    method: 'post',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/request/account.js